<template>
  <v-bottom-navigation
    v-model="value"
    :input-value="active"
    fixed
    scroll-threshold="500"
    height="96"
  >
    <v-row class="ma-0 py-5 px-6 btn-fixed-wrapper">
      <v-col cols="12">
        <v-btn
          block
          elevation="0"
          class="btn-fixed btn-blue"
          @click="$emit('onClickApplyBtn')"
        >
          <span class="white--text">적용</span>
        </v-btn>
      </v-col>
    </v-row>
  </v-bottom-navigation>
</template>

<script>
/*
 * 모달 하단 적용버튼 컴포넌트
 */
export default {
  data() {
    return {
      value: 1,
      active: true,
    };
  },
};
</script>
